module.exports = __webpack_public_path__ + "static/media/mandrill_icon.7413c15f.svg";